<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CbCcha/tc-custom/9780470893708.jpg?1740467859457" alt="This image is the cover for the book Self-Coaching"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Self-Coaching
      </h1>
      <p class="bookDescription body article font2">
        <p>The simple, untold truth about anxiety and depression is that they are habits of insecurityand, like all habits, they can be broken. In this new edition of the highly successful Self-Coaching, Dr. Joseph Luciani shows you how to change your way of thinking and develop a healthy, adaptive way of living through his proven Self-Talk strategy for coaching yourself back to health.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph J. Luciani
      </h2>
      
      <p class="authorDescription body article">JOSEPH J. LUCIANI, Ph.D., is the author of the internationally bestselling Self-Coaching series. As a frequent lecturer, TV and radio guest, and author, he has brought his message of hope to millions over the years. Dr. Luciani, a clinical psychologist, has been in general private practice since 1977.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wiley
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c7d43df